module.exports = __webpack_public_path__ + "img/b1-4-4-1.ee8b4dcc.jpg";